const LOCAL_BASE_URL = process.env.REACT_APP_LOCAL_BASE_URL;

const featureBranches = [
  'feature-1',
  'feature-2',
  'gryffindor',
  'hobbiton',
  'hufflepuff',
  'ravenclaw',
  'rohan',
  'pre-prod',
  'slytherin',
];

function getDomain() {
  const domain = window.location.hostname;
  const parts = domain.split('.');
  const subdomain = parts[0];
  const mainDomain = parts.slice(1).join('.');
  const isLocalhost = domain.includes('localhost');
  return { subdomain, mainDomain, isLocalhost };
}

function getWebsoketKey() {
  const stagingKey = process.env.REACT_APP_PUSHER_APP_STAGING_KEY;
  const prodKey = process.env.REACT_APP_PUSHER_APP_PROD_KEY;

  const { subdomain } = getDomain();
  if (subdomain === 'stage' || featureBranches.includes(subdomain)) {
    return stagingKey;
  }

  return prodKey;
}

function getApiUrl() {
  const { subdomain, mainDomain, isLocalhost } = getDomain();

  if (isLocalhost && LOCAL_BASE_URL) {
    return LOCAL_BASE_URL;
  }

  // stage environments
  if (subdomain === 'stage') {
    return `https://api-stage.${mainDomain}/api`;
  }

  // prod environments
  if (subdomain === 'prod') {
    return `https://api.${mainDomain}/api`;
  }

  // pre-prod environments
  if (subdomain === 'pre-prod' || featureBranches.includes(subdomain)) {
    return `https://api-${subdomain}.${mainDomain}/api`;
  }

  return `https://api.${mainDomain}/api`;
}

export const BASE_URL = getApiUrl();
export const WEBSOCKET_KEY = getWebsoketKey();
